<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import LeistungstabelleEineLinieZeile from "@/components/leistungstabelle/LeistungstabelleEineLinieZeile.vue";
import IconSprite from "@/components/IconSprite.vue";

export default defineComponent({
  name: "LeistungstabelleEineLinie",
  components: { LeistungstabelleEineLinieZeile, IconSprite },
  props: {
    inhalt: {
      type: Array,
      required: true,
    },
    link: {
      type: String,
      required: true,
      default: "",
    },
    linkFhVgv: {
      type: String,
      required: false,
      default: "",
    },
    linkFhVhv: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props) {
    const isAusgeklappt = ref(false);

    function zeigeInhalt() {
      isAusgeklappt.value = !isAusgeklappt.value;
    }

    watch(
      () => props.inhalt,
      () => {
        // Bei Änderung des Leistungsumfangs die Tabelle einklappen, da sonst neuer Inhalt nicht populiert wird.
        // Dies kann bei FH passieren, wenn VersUmfang (VGV, VHV) geändert wird.
        isAusgeklappt.value = false;
      },
    );

    return {
      isAusgeklappt,
      zeigeInhalt,
      props,
    };
  },
});
</script>

<template>
  <div class="o-grid">
    <div class="o-grid__cell o-grid__cell--12 u-form-grid-nospace-y">
      <div class="collapse-tarif">
        <div class="c-collapse c-collapse--is-initialized" data-collapse="data-collapse" data-collapse-multiple="true">
          <div
            class="c-collapse__item"
            v-bind:class="{
              'c-collapse__item--is-expanded': isAusgeklappt,
              'c-collapse__item--is-collapsed': !isAusgeklappt,
            }"
            style="height: 56px"
          >
            <div class="o-grid o-grid--no-y-gutter table-tariff-collapse-wrapper">
              <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480"></div>
              <div
                class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 table-switcher button-select"
              >
                <div class="o-grid o-grid--no-y-gutter">
                  <div class="collapse-switcher table-wide-button table-wide-button__header">
                    <button
                      class="c-collapse__header no-outline"
                      aria-expanded="false"
                      id="collapse-tariff-table-button"
                      aria-controls="collapse-tariff-table"
                      type="button"
                      @click="zeigeInhalt"
                    >
                      <span class="c-collapse__header-with-icon">Leistungsübersicht</span>
                      <icon-sprite icon-name="icon-arrow-up" css-klassen="c-collapse__icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="isAusgeklappt"
              class="c-collapse__content"
              aria-labelledby="collapse-tariff-table-button"
              id="collapse-tariff-table"
            >
              <div
                class="c-collapse c-collapse--is-initialized"
                data-collapse="data-collapse"
                data-collapse-multiple="true"
              >
                <div class="tariff-details-table js-tarifoptions-table">
                  <div class="o-grid gimmick gimmick__top">
                    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 gimmick-left-col" />
                    <div
                      class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 gimmick-right-col"
                    >
                      <div class="o-grid o-grid--no-y-gutter add-on">
                        <div class="tariff-column-1 add-on__option" />
                        <div class="tariff-column-2 add-on__option" />
                        <div class="tariff-column-3 add-on__option" />
                      </div>
                    </div>
                  </div>
                  <leistungstabelle-eine-linie-zeile v-if="isAusgeklappt" :zeilen="props.inhalt" />
                </div>
                <div class="o-grid o-grid--no-y-gutter">
                  <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480"></div>
                  <div
                    class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
                  >
                    <div v-if="link" class="o-grid o-grid--no-y-gutter table-wide-button table-wide-button__footer">
                      <a :href="link" :download="link" target="_blank">
                        Detaillierte Leistungsbeschreibung herunterladen
                      </a>
                    </div>
                    <div
                      v-else-if="linkFhVgv || linkFhVhv"
                      class="o-grid o-grid--no-y-gutter table-wide-button table-wide-button__footer"
                    >
                      <span>
                        Detaillierte Leistungsbeschreibung herunterladen:<br />
                        <a :href="linkFhVgv" :download="linkFhVgv" target="_blank"> Wohngebäudeversicherung</a>
                        |
                        <a :href="linkFhVhv" :download="linkFhVhv" target="_blank"> Hausratversicherung </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
